"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { initTracker, trackPageview } from "@/lib/analytics";
import { gaPageview } from "@/lib/gtag";

export default function AnalyticsTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    initTracker();
  }, []);

  useEffect(() => {
    if (!pathname) return;
    if (pathname.startsWith("/admin") || pathname.startsWith("/api")) return;
    // small delay so document.title is updated after navigation
    const t = setTimeout(() => {
      trackPageview(window.location.href, document.title);
      gaPageview(window.location.pathname + window.location.search, document.title);
    }, 50);
    return () => clearTimeout(t);
  }, [pathname, searchParams]);

  return null;
}
